<template>
  <div class="account-management-page">
    <div class="account-management-container">
      <transition name="fade" mode="out-in">
        <section v-if="sectionTitle && customerIds.length" class="heading">
          <h2>{{ $t('servicesAccountManagement.title') }}</h2>
          <base-button @click="deleteAllAccounts()" class="no-border">{{
              $t('servicesAccountManagement.deleteAll')
            }}
          </base-button>
        </section>
      </transition>
    </div>
    <connected-services @cancel-add="showTitle" @show-password="hideTitle" @id-fetched="fetchData" delete-account/>

    <modal size="lg"
           :visible="modalVisible"
           :close-button-visible="false">
      <div class="delete-header">
        <img src="/assets/images/delete-warning.svg" alt="" class="warning-img">
        <h2>{{ $t('servicesAccountManagement.deleteModal.titleDeleteAll') }}</h2>
      </div>
      <div class="delete-body">
        <p class="description">
          {{ $t('servicesAccountManagement.deleteModal.descriptionDeleteAll') }}</p>
        <div class="button-container">
          <base-button variant="primary" @click="confirmDelete" :disabled="loadingData">
            {{ $t('servicesAccountManagement.deleteModal.confirmDeleteAll') }}
          </base-button>
          <button class="cancel-btn" @click="cancelDelete">
            {{ $t('servicesAccountManagement.deleteModal.cancel') }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ConnectedServices from '@/components/services/connectServices/connected-services'
import Modal from '@/components/common/modal/modal'
import logout from '@/mixins/logout'
import errorMessageHandler from '@/mixins/errorMessageHandler'

export default {
  name: 'user-account-management',
  components: { ConnectedServices, Modal },
  data () {
    return {
      modalVisible: false,
      customerIds: [],
      connectedServices: [],
      sectionTitle: true,
      loadingData: false
    }
  },
  mixins: [logout, errorMessageHandler],
  methods: {
    hideTitle () {
      this.sectionTitle = false
    },
    showTitle () {
      this.sectionTitle = true
    },
    backToStepOne (refresh = false) {
      this.passwordEntryForConnectedService = false
      if (refresh) {
        // this.$refs.connectedServices.getReconnectionData()
        this.$emit('refresh-side-nav')
      }
    },
    deleteAllAccounts () {
      this.modalVisible = true
    },
    deleteAccount (customerId) {
      return new Promise((resolve, reject) => {
        this.$apiRequest.delete(`user/service/disconnect?customerId=${customerId}`)
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject(new Error('Can\'t delete account'))
          })
      })
    },
    confirmDelete (index = 0) {
      this.loadingData = true
      const successCount = index + 1
      if (index < this.customerIds.length) {
        this.deleteAccount(this.customerIds[index])
          .finally(() => {
            this.confirmDelete(index + 1)
          })
      } else {
        if (successCount >= this.customerIds.length) {
          this.toast('success', {
            title: this.$t('toastMessages.deletedAllAccountsNotificationTitle'),
            message: this.$t('toastMessages.deletedAllAccountsNotificationMessage')
          })
          this.customerIds = []
          setTimeout(() => {
            this.loadingData = false
            this.logoutUser()
          }, 3000)
        } else {
          this.toast('error', {
            message: this.$t('errors.defaultError')
          })
          setTimeout(() => {
            this.loadingData = false
            window.location.reload()
          }, 3000)
        }
      }
    },
    cancelDelete () {
      this.modalVisible = false
    },
    fetchData (customerIds) {
      this.customerIds = customerIds
    }
  }
}

</script>

<style lang="scss">
.account-management-page {
  padding: 4rem 1.5rem;

  @media (map_get($breakpoints, md)) {
    padding: 2rem 0;
  }

  .account-management-container {
    .base-button.no-border {
      background: transparent;
      color: $primary;
      font-size: 1.6rem;
      font-weight: 600;
      padding: 1rem 0;
      text-align: right;
    }

    .heading {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid $tab-border-color;

      h2 {
        font-size: 24px;
        font-weight: normal;
        color: $light-black;
        text-transform: uppercase;
      }
    }

    .connected-services {
      width: 100%;

      .service-title {
        border-bottom: none;
      }
    }

  }
}

.hide {
  display: none;
}
</style>
